import { Suspense, lazy } from "react";

const MarkdownContent = lazy(() => import("./MarkdownContent"));

type MarkdownContentLazyProps = {
  content: string;
  rtl?: boolean;
  lang?: string | null;
};

// Lazy wrapper so react-markdown + remark-gfm land in their own async chunk,
// fetched only when ai.md content is actually shown. Until the chunk streams
// in, the raw text is rendered (pre-wrap) so nothing flashes empty.
const MarkdownContentLazy = (props: MarkdownContentLazyProps) => (
  <Suspense
    fallback={
      <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
        {props.content}
      </div>
    }
  >
    <MarkdownContent {...props} />
  </Suspense>
);

export default MarkdownContentLazy;
